import { LngLat } from 'mapbox-gl';

export default class lngLat {
  #lngLat
  constructor(latitude, longitude) {
    this.#lngLat = createMapboxLatLong(latitude, longitude);
  }

  get() {
    return this.#lngLat;
  }
}

function createMapboxLatLong(latitude, longitude) {
  return new LngLat(longitude, latitude);
}
